import { render, staticRenderFns } from "./VisualizarListaPresencaDialog.vue?vue&type=template&id=3187f8a6&scoped=true"
import script from "./VisualizarListaPresencaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarListaPresencaDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarListaPresencaDialog.vue?vue&type=style&index=0&id=3187f8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187f8a6",
  null
  
)

export default component.exports